<template>
  <div class="commont-box">
    <div class="footer-content commont-content">
      <a-row>
        <a-col span="9">
          <p class="footer-text">关于我们</p>
          <p class="footer-text">
            图启建科旗下结构计算网致力于为建筑业提供领先的数字化转型服务，通过创新技术赋能建筑设计、施工、运维全生命周期。
            公司成立10年来，逐步确立了SaaS订阅制为主的基础模式，并且为中海油、中建、中交等多家大型央企/国企提供了定制化服务，
            聚焦建筑行业垂直领域，提供覆盖BIM、AI、云计算、物联网的协同化、数据驱动的软件解决方案。推动建筑业高效、绿色、智能化发展。          
          </p>
        </a-col>
        <a-col span="1">
        </a-col>
        <a-col span="9">
          <p class="footer-text">商务咨询 | 定制开发</p>
          <p class="footer-text">结构计算网开发团队25年+建筑行业深耕，懂设计、施工、管理全流程程痛点！专注数字未来，智造行业标杆，是您的建筑软件定制专家。</p>
          <p class="footer-text">深耕行业理解 | 精准需求落地 | 技术栈全覆盖 | 交付即服务</p>
          <p class="footer-text">
           <a><MailOutlined />电话:&nbsp;&nbsp;021-50116038</a>&nbsp; &nbsp;<a><MailOutlined />微信:&nbsp;&nbsp;famousbuild</a>
          </p>
        </a-col>
        <a-col span="3" align=center>
          <p class="footer-text">问题解答 | 客户服务</p><center>
          <p class="footer-text">
            <img src=http://36.150.110.246:8091/pic/famousbuild1.jpg width=120 id="refreshImage" style="cursor:pointer;" onclick="document.getElementById('refreshImage').src = document.getElementById('refreshImage').src + '?' + new Date().getTime();"/>            
          </p></center>
        </a-col>   
        <a-col span="2" align=center>
          <p class="footer-text">微信公众号</p><center>
          <p class="footer-text">
            <img src=http://36.150.110.246:8091/pic/famousbuild2.jpg width=120 />            
          </p></center>
        </a-col>     
      </a-row>
      <a-row>
        <a-col span="24">
          <p class="footer-conpyright">
            Copyright © 2025-上海图启建筑科技股份有限公司版权所有
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              style="color: #000"
              >&nbsp;沪ICP备15030720号-2</a>
          </p>
        </a-col>
        </a-row>
    </div>
  </div>
  <AboutUs ref="aboutUs" />
</template>

<script>
import { ref } from "vue";
import AboutUs from "@/views/home/AboutUs.vue";
export default {
  name: "HomeFooter",
  components: {
    AboutUs,
  },
  setup() {
    const aboutUs = ref(null);

    const aboutMe = () => {
      aboutUs.value.showModal();
    };

    return {
      aboutUs,
      aboutMe,
    };
  },
};
</script>

<style lang="less" scoped>
.commont-box {
  width: 100%;
  background-color: #1890ff;
  margin-top: 20px;
}
.commont-content {
  max-width: 1200px;
  margin: 0 auto;
}
.footer-content {
  padding: 20px 0;
  .footer-text {
    color: #fff;

    a {
      color: #fff;
    }

    a:hover {
      color: #000;
    }
  }
  .footer-conpyright {
    .px2vh(margin-top, 16);
    text-align: center;
    margin-bottom: 0;
  }
}
</style>